import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModel from "../../commons/base/view_model";
import GetShopeeOrdersResponse from "../models/get_shopee_orders_response";
import Order from "../models/order_model";
import ShopeeOrderDashboardState from "../models/shopee_order_dashboard_state";

export default class ShopeeOrderDashboardViewModel extends ViewModel<ShopeeOrderDashboardState> {

    constructor() {
        super({
            errorMessage: "",
            orderArr: [],
            isLoading: true
        });
        this.loadData()
    }

    loadData() {
        ApiService.fetch<{}, BaseResponse<GetShopeeOrdersResponse>>(
            Endpoints.getShopeeOrders,
            {
                onSuccess: (response) => {
                    if (response.code == 200) {
                        if (response.data && response.data.orderData) {
                            let newData = response.data.orderData;

                            let newOrderArr: Order[] = [];
                            if (this.state.orderArr.length == 0) {
                                newOrderArr = newData;
                            } else {
                                for (let i = 0; i < newData.length; i++) {

                                    // check if we already have the order
                                    let exist = false;
                                    for (let j = 0; j < this.state.orderArr.length; j++) {
                                        if (newData[i].orderId === this.state.orderArr[j].orderId) {
                                            exist = true;
                                        }
                                    }
                                    if (!exist) {
                                        newOrderArr.push(newData[i]);
                                    }
                                }
                            }
                            
                            // place all new orders at the top of the table
                            newOrderArr.push(...this.state.orderArr);

                            this.emit((state) => {
                                state.isLoading = false;
                                state.orderArr = newOrderArr
                            });
                        }
                    }
                },
                onFailure: (error, errorCode) => {
                    this.emit((state) => {
                        state.errorMessage = "Koneksi internet sempat terganggu, silakan refresh";
                        state.isLoading = false;
                    });
                }
            }
        );
    }
    
    setCollectedByDriver(orderId: string) {
        this.emit((state) => {
            state.isLoading = true;
        });

        ApiService.fetch<{}, BaseResponse<{ orderId: string }>>(
            Endpoints.setCollectedByDriver,
            {
                httpMethod: HttpMethod.post,
                parameters: {
                    orderId: orderId
                },
                onSuccess: (response) => {
                    const deletedOrderId = response.data?.orderId;
                    if (deletedOrderId) {
                        this.emit((state) => {
                            state.isLoading = false;
                            state.orderArr = state.orderArr.filter((order) => order.orderId != deletedOrderId);
                        });
                    }
                },
                onFailure: (error, errorCode) => {
                    this.emit((state) => {
                        state.errorMessage = "Koneksi internet sempat terganggu, silakan refresh";
                        state.isLoading = false;
                    });
                }
            }
        )
    }
}